import { render, staticRenderFns } from "./StudyTags.vue?vue&type=template&id=ca27885c&scoped=true"
import script from "./StudyTags.vue?vue&type=script&lang=js"
export * from "./StudyTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca27885c",
  null
  
)

export default component.exports